<template>
  <v-dialog
    width="500"
    v-bind="$attrs"
    v-on="$listeners"
    @click:outside="onCancel"
  >
    <v-card>
      <v-card-title>
        Incluir Tópico
      </v-card-title>
      <v-card-text>
        <div class="row">
          <div class="col-12">
            <EducationSystemSelect
              @setEducationSystem="parameters.education_system_id = $event"
            />
          </div>
          <div class="col-12">
            <EducationStageSelect
              :education-system-id="parameters.education_system_id"
              @setEducationStage="parameters.education_stage_id = $event"
            />
          </div>
          <div class="col-12">
            <GradeSelect
              :education-stage-id="parameters.education_stage_id"
              @setGrade="parameters.grade_id = $event"
            />
          </div>
        </div>
      </v-card-text>
      <v-card-text>
        <div class="d-flex justify-space-between">
          <v-btn
            color="primary"
            text
            @click="onCancel"
          >
            Fechar
          </v-btn>
          <v-btn
            color="primary"
            text
            :disabled="parameters.grade_id === null"
            @click="save()"
          >
            Incluir
          </v-btn>
        </div>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import EducationSystemSelect from '@/components/contents/EducationSystemSelect.vue'
import EducationStageSelect from '@/components/contents/EducationStageSelect.vue'
import GradeSelect from '@/components/contents/GradeSelect.vue'

export default {
  components: {
    EducationSystemSelect,
    EducationStageSelect,
    GradeSelect
  },

  data: () => ({
    parameters: {
      education_system_id: null,
      education_stage_id: null,
      grade_id: null
    }
  }),

  methods: {
    onCancel () {
      this.$emit('resolve', false)
    },
    save () {
      this.$emit('resolve', this.parameters.grade_id)
    }
  }
}
</script>
